import Model, { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class GoogleAriLinkModel extends Model {
  @attr('boolean') listable!: boolean;

  @belongsTo('property', { inverse: 'googleAriLink', async: false })
  property!: ModelRegistry['property'];
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'google-ari-link': GoogleAriLinkModel;
  }
}
